import HeroSection from "./components/HeroSection";
import TrustBar from "./components/TrustBar";
import CategorySection from "./components/CategorySection";
import ComparisonSection from "./components/ComparisonSection";
import ContentSections from "./components/ContentSections";

export default function Home() {
  return (
    <div className="bg-background-50">
      <HeroSection />
      <TrustBar />
      <CategorySection />
      <ComparisonSection />
      <ContentSections />
    </div>
  );
}